/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-28 15:55:18
 * @FilePath: \mrc-ess-fronted\src\plugins\vuetify.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-09 13:23:25
 */
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
Vue.use(Vuetify);
import zhHans from "vuetify/es5/locale/zh-Hans";
import en from "vuetify/es5/locale/en";
import ja from "vuetify/es5/locale/ja";
import th from "vuetify/es5/locale/th";

// import preset from "@/@core/preset/preset";

import theme from "@/plugins/theme";
const opts = Object.assign(
  process.env.VUE_APP_theme === "other"
    ? { preset: require("@/@core/preset/preset")["default"] }
    : {},
  {
    breakpoint: { scrollbarWidth: 6, mobileBreakpoint: 1265 },
    theme: Object.assign(
      {
        options: {
          customProperties: true, //开启后可在全局使用vuetify变量
          variations: true, //开启后可配置theme，primary，base
        },
      },
      process.env.VUE_APP_theme === "other"
        ? {}
        : {
            themes: {
              ...theme.themes,
            },
          }
    ),
    icons: {
      iconfont: "md",
    },
    lang: {
      locales: { zhHans, en, ja, th },
      current: "en",
    },
  }
);
// console.log(opts);
export default new Vuetify(opts);
